module.exports = __webpack_public_path__ + "img/nora.c1fe577d.png";